<div *ngIf="active">
  <div [ngClass]="active ? 'active' : ''" class="modal-background"></div>
  <div [ngClass]="active ? 'active' : ''" class="modal">
    <div class="header" *ngIf="data.title">
      <h2>{{ data.title }}</h2>
    </div>
    <div class="content">
      {{ data.content }}
      <ul *ngIf="data.listItems">
        <li *ngFor="let item of data.listItems">{{ item }}</li>
      </ul>
    </div>
    <div class="buttons">
      <button
        (click)="clickedConfirm($event)"
        class="primary-btn green"
        mat-button
        ><mat-icon class="icon" *ngIf="data.confirmIcon">{{ data.confirmIcon }}</mat-icon> {{ data.confirm }}</button>
      <button
        mat-button
        *ngIf="data.secondaryOption"
        (click)="clickedSecondary($event)"
        class="primary-btn"
        ><mat-icon class="icon" *ngIf="data.secondaryIcon">{{ data.secondaryIcon }}</mat-icon>{{ data.secondaryOption }}</button>
      <button
        mat-button
        (click)="clickedDeny($event)"
        class="alert-btn"
      >{{ data.deny }}</button>
    </div>
  </div>
</div>
